import React, { useState, useEffect } from "react";

// API
import useAxios from "../../../../hooks/useAxios";
import jsonFormatAuth from "../../../../apis/jsonFormatAuth";
import { Heading1 } from "../../../../components/Headings/Headings";
import { ArrowPathIcon, PlusCircleIcon } from "@heroicons/react/24/outline";
import {
  SquareIconNavButton,
  TextIconUtilityButton,
} from "../../../../components/Buttons/Buttons";

import { useDispatch } from "react-redux";
import { setActivePage } from "../../../../redux/features/applicationState/applicationStateSlice";
import DataTable from "../../../../components/DataTable/DataTable";

function PatientDatabaseScreen() {
  const dispatch = useDispatch();
  const { response, axiosFetch } = useAxios();

  // Table
  const [patientData, setPatientData] = useState([]);
  const [userTags, setUserTags] = useState([]);

  const getData = () => {
    axiosFetch({
      axiosInstance: jsonFormatAuth(),
      method: "GET",
      url: "patients/patient_menu",
      sendSignal: false,
      requestConfig: {},
    });
  };

  useEffect(() => {
    // Obtaining data from API on initial page load
    getData();
  }, []);

  // RESPONSE Detection
  useEffect(() => {
    // Patients data received.
    if (response) {
      if (response?.action_code === "patients_sent") {
        setPatientData(response?.payload?.patients_data || []);
        setUserTags(response?.payload?.tags || []);
      }
    }
  }, [response]);

  // API End

  return (
    <div className="flex flex-col flex-grow items-center w-full pb-4 md:pb-0 Xbg-lime-500">
      <div className="flex flex-col md:flex-row items-center justify-between w-full Xbg-red-500">
        <div className="flex flex-row items-center justify-start w-full Xbg-green-500">
          <Heading1 headingText={"Patients"} />
        </div>
        <div className="flex flex-row space-x-4 items-center justify-end w-full h-full pt-5 pb-2 Xbg-yellow-500">
          <div className="flex-grow md:flex-grow-0">
            <SquareIconNavButton
              Icon={ArrowPathIcon}
              actionFunction={getData}
              activeColor={"active:bg-cyan-100"}
            />
          </div>

          <div className="flex-grow md:flex-grow-0">
            <TextIconUtilityButton
              Icon={PlusCircleIcon}
              prompt={"New Patient"}
              iconSide={"right"}
              activeColor={"active:bg-green-100"}
              actionFunction={() => {
                dispatch(setActivePage("/patients/create"));
              }}
              pageLink={"/patients/create"}
            />
          </div>
        </div>
      </div>

      <div className="py-2" />

      {/* <div className="outline">{JSON.stringify(patientData)}</div> */}

      <DataTable
        data={patientData}
        dataTags={userTags}
        rowType={"patient"}
        showFilter={true}
        showPageNav={true}
      />
    </div>
  );
}

export default PatientDatabaseScreen;
